exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n@font-face {\n  font-family: 'Effra';\n  font-style: normal;\n  font-weight: normal;\n  src: local('Effra'), url(" + require("./assets/effra.woff") + ") format('woff');\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader?{"ident":"postcss"}!./src/styles.css
// module id = 384
// module chunks = 2